/*
    Catalogue Models
*/

export class StoreListingTableModel {
  constructor() {
    this.catalogueCode = '';
    this.catalogueId = '';
    this.catalogueName = '';
    this.featuredOnLeadPage = false;
    this.storeListingId = '';
    this.storeListingUrl = '';
    this.storeListingName = '';
  }
}
export class StudentResourceTableModel {
  constructor() {
    this.resourceId = '';
    this.name = '';
    this.type = '';
    this.resourceUrl = '';
    this.size = '';
  }
}

export class CatalogueSubscriptionTableModel {
  constructor() {
    this.label = '';
    this.type = '';
    this.duration = '';
    this.price = 0;
    this.featured = '';
    this.status = '';
  }
}

export class TableEditBarModel {
  constructor() {
    this.openEditBar = []; // set [] for false and [0] for true
    this.buttonConfig = [];
  }
}

export class EditBarButtonConfig {
  constructor() {
    this.buttonText = '';
    this.buttonIcon = '';
    this.onClick = () => {};
  }
}

export class CatalogueListTableModel {
  constructor() {
    this.catalogueId = '';
    this.catalogueName = '';
    this.duration = 0;
    this.trialVideoDuration = 0;
    // this.publishState = false;
    // this.publishingInfo = null;
    this.storeListed = false;
    this.subjects = 0;
    this.trialInfo = 0;
    this.recipients = [];
  }
}

export class AddOnPopupModel {
  constructor() {
    this.name = '';
    this.description = '';
    this.price = 0;
    this.disableButton = true;
  }
}

export class TestimonialPopupModel {
  constructor() {
    this.image = '';
    this.firstName = '';
    this.lastName = '';
    this.title = '';
    this.description = '';
    this.disableButton = true;
  }
}

class SubscriptionDrawerFormModel {
  constructor() {
    this.subscriptionLabel = '';
    this.subscriptionType = '';
    this.numberOfMonths = '';
    this.subscriptionEndDate = '';
    this.price = '';
    this.featured = 'false';
  }
}

class SubscriptionOtsProducts {
  constructor() {
    this.productLabel = '';
    this.groupCode = '';
    this.packageCode = '';
  }
}

export class CurrentCatalogueErrorsModel {
  constructor() {
    this.step1 = false;
    this.step2 = false;
  }
}

export class CurrentStoreListingErrorModel {
  constructor() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = false;
  }
}

/*
  CATEGORY MODELS
*/

export class AddCategoryModel {
  constructor() {
    this.categoryName = '';
    this.publishState = false;
    this.catalogues = [];
    this.subCategories = [];
  }
}

export class AddSubCategoryModel {
  constructor() {
    this.subCategoryName = '';
    this.catalogues = [];
  }
}

/*
  CATALOGUE MANAGER MODEL START
*/

export class CataloguePayloadModel {
  constructor() {
    this.archived = false;
    this.catalogueInfo = new CatalogueInfoModel();
    this.cataloguePublisher = new CataloguePublisherModel();
    this.catalogueTheme = new CatalogueThemeModel();
    this.createdBy = '';
    this.resources = [];
    this.storeListed = false; // Doubt
    this.subjects = [];
  }
}

export class CatalogueInfoModel {
  constructor() {
    this.catalogueName = '';
    this.catalogueCode = '';
    this.description = '';
  }
}

export class CataloguePublisherModel {
  constructor() {
    this.publisherName = '';
    this.publisherLogoLink = '';
  }
}
export class CatalogueThemeModel {
  constructor() {
    this.images = [];

    this.colour = '#ffffff';
    this.courseCardColorInfo = new CourseCardColorInfoModel();
    this.courseDashboardColorInfo = new CourseDashboardColorInfoModel();
  }
}

export class CourseCardColorInfoModel {
  constructor() {
    this.cardBackgroundColor = '';
    this.catalogueCodeFontColor = '';
    this.completionTextColor = '';
    this.progressBarBackgroundColor = '';
    this.progressBarCompletionColor = '';
  }
}

export class CourseDashboardColorInfoModel {
  constructor() {
    this.activeStateColor = '';
    this.backgroundColor = '';
  }
}
export class ImageModel {
  constructor() {
    this.imageLink = '';
    this.imageSize = 0;
    this.catalogueImageType = '';
  }
}

export class SubjectsModel {
  constructor() {
    this.subjectId = '';
    this.subjectName = '';
    this.imagePath = '';
    this.videoCount = 0;
    this.videoDurationInSecond = 0;
    this.unitCount = 0;
    this.trialVideoCount = 0;
    this.version = 1;
    this.comingSoon = false;
    this.updatesAvailable = false;
    this.subjectSubscriptionList = [];
    this.tags = [];
  }
}

export class ResourceModel {
  constructor() {
    this.resourceName = '';
    this.resourceUrl = '';
    this.resourceType = '';
    this.size = '';
  }
}

/*
  CATALOGUE MANAGER MODEL ENDS
*/

/*
  STORE MANAGER MODEL STARTS
*/

export class StoreListingPayloadModel {
  constructor() {
    this.storeListingName = '';
    this.storeListingCode = '';
    this.createdBy = '';
    this.category = new CategoryModel();
    this.storeIconUrl = '';
    this.previewVideos = [];
    this.examSyllabus = '';
    this.examPattern = '';
    this.preparationTips = '';
    this.programs = [];
    this.storeListingHours = '';
    this.sameAsCatalogueHours = true;
    this.featuredOnHomePage = false;
    this.featuredOnLeadPage = false;
    this.studentTargetYear = [];
    this.questionPapers = [];
    this.faqs = [];
  }
}

// class Batch {
//   constructor() {
//     this.batchId = '';
//     this.batchCode = '';
//     this.batchLanguage = '';
//     this.startTime = '';
//   }
// }

// class Subscription {
//   constructor() {
//     this.subscriptionLabel = '';
//     this.subscriptionType = '';
//     this.featured = true;
//     this.price = '';
//     this.archived = false;
//     this.otsList = [];
//     this.numberOfMonths = '';
//   }
// }

// class ProgramModel {
//   constructor() {
//     this.programType = '';
//     this.title = '';
//     this.subtitle = '';
//     this.programTargetYear = new StudentTargetYear();
//     this.shortDescription = '';
//     this.longDescription = '';
//     this.catalogueId = '';
//     this.catalogueName = '';
//     this.features = [];
//     this.batches = [new Batch()];
//     this.addons = [];
//     this.freeAddOn = false;
//     this.subscriptions = [new Subscription()];
//     this.recommended = false;
//   }
// }

// class StudentTargetYear {
//   constructor() {
//     this.id = '';
//     this.title = '';
//   }
// }

export class CategoryModel {
  constructor() {
    this.categoryId = '';
    this.categoryName = '';
    this.subCategory = new SubCategoryModel();
  }
}

export class SubCategoryModel {
  constructor() {
    this.subCategoryId = '';
    this.subCategoryName = '';
  }
}

export class PreviewVideosModel {
  constructor() {
    this.subjectName = '';
    this.tag = '';
    this.title = '';
    this.videoUrl = '';
    this.thumbnail = '';
  }
}

export class SubscriptionModel {
  constructor() {
    this.subscriptionLabel = '';
    this.subscriptionType = '';
    this.price = 0;
    this.subscriptionEndDate = '';
    this.numberOfMonths = 0;
  }
}

export class AddOnsModel {
  constructor() {
    this.addOnName = '';
    this.price = '';
    this.description = '';
    this.automationType = '';
  }
}

export class TestimonialModel {
  constructor() {
    this.firstName = '';
    this.lastName = '';
    this.authorImage = '';
    this.description = '';
    this.title = '';
  }
}

export class FaqModel {
  constructor() {
    this.question = '';
    this.answer = '';
  }
}
export class QuestionPaperModel {
  constructor() {
    this.questionPaperName = '';
    this.questionPaperUrl = '';
  }
}

/*
  STORE MANAGER MODEL STARTS
*/

/*
  OTS Manager Models
*/

export class OtsCatalogueTableModel {
  constructor() {
    this.catalogueName = '';
    this.catalogueCode = '';
    this.storeListing = '';
  }
}

export class OtsSubscriptionProductModel {
  constructor() {
    this.productLabel = '';
    this.packageCode = '';
    this.groupCode = '';
    this.status = 'CREATED';
  }
}

export class OtsPayloadSubscriptionModal {
  constructor() {
    this.otsList = [];
    this.subscriptionId = '';
    this.subscriptionLabel = '';
    this.subscriptionType = '';
    this.featured = false;
    this.price = 0;
    this.numberOfMonths = 0;
  }
}

export class OtsSubscriptionByIdPayloadModal {
  constructor() {
    this.storeListingId = '';
    this.subscription = new OtsPayloadSubscriptionModal();
    this.usageStatus = false;
  }
}

export { SubscriptionDrawerFormModel, SubscriptionOtsProducts };
